/* 🤖 this file was generated by svg-to-ts */
export const matIconFilter5: {
  name: 'filter-5';
  data: string;
} = {
  name: 'filter-5',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2a2 2 0 0 0-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 0 0 2-2z"/></svg>`
};
